import React, { useContext, useState, useEffect } from 'react'
import { useHistory, NavLink } from 'react-router-dom'
import CustomTable from '@/product/components/molecules/CustomTable'
import SettingContext from '@/product/context/seller/setting/settingContext'
import AuthContext from '@/product/context/auth/authContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import DashboardLayout from '@/views/Dashboard/DashboardLayout'
import { useTranslation } from 'react-i18next'

const MySubscriptionList = (props) => {
    const { user, isAuthenticated } = useContext(AuthContext)
    const [isLoading, setIsLoading] = useState(true)
    const {
        searchTableAction,
        searchTable,
        table_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseSetting,
    } = useContext(SettingContext)
    const { t } = useTranslation()
    const [tableBody, setTableBody] = useState([])
    const [data, setData] = useState([])
    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            count: 1,
            order: '',
            orderby: '',
            table: 'user_memberships',
            filters: {
                fields: {
                    value: user?.id ? user.id : null,
                    type: 'in',
                    field: 'usm.user_id',
                },
            },
            tableJoins: [
                {
                    baseTable: 'users',
                    // customTable: 'users',
                    joinType: 'inner',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
                {
                    baseTable: 'bidding_plan',
                    // customTable: 'users',
                    joinType: 'inner',
                    baseJoinField: 'type',
                    connectJoinField: 'membership',
                },
            ],
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTable(values)
        },
    })
    useEffect(() => {
        setIsLoading(true)
        if (user && user.id) {
            formik.values.filters.fields.value = user.id
            searchTable(formik.values, 'getReview')
        }
    }, [user?.id])
    useEffect(() => {
        console.log('table_data====>', table_data)
        if (table_data && table_data.records.length) {
            setTableBody(table_data.records)
            setData(table_data)
        }
        setIsLoading(false)
    }, [table_data])
    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: t('ID'),
        },
        {
            field: 'bidding_plan_plan_name',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('Plan'),
        },
        {
            field: 'membership_date',
            type: 'date',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('Start Date'),
        },
        {
            field: 'membership_enddate',
            type: 'date',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('End Date'),
        },
        {
            field: 'membership_period',
            type: 'capitalize',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('Period'),
        },
        {
            field: 'amount',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('Amount'),
        },
    ]
    let tableActions = []
    return (
        <>
            <DashboardLayout title={'My Subscription Transactions'}>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={data}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTable}
                />
            </DashboardLayout>
        </>
    )
}

export default MySubscriptionList
